import { EditCoursePage } from '@hendrx/core/courses';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/studio/courses/edit/$courseDraftId/')({
  component: EditCoursePage
});
